import React from 'react';
import { getContext } from 'common';
import _merge from 'lodash/merge';
import CardCore, { CardCoreProps } from './CardCore';
import Styled from './styles';

export interface SimpleCardProps extends CardCoreProps {
  /** Toggle between visual variants of Card.
   *  'stack' -  shows multiple cards stacked together (for use when indicating that there are multiple cards under this card)
   *  'modal' -  toggles modal styles
   */
  variant?: 'default' | 'stack' | 'modal';
  /** Content is placed here. */
  children: React.ReactNode;
  /** Set width of the card. If unset, card takes up width of container. */
  width?: number;
  /** Set height of the card. If unset, card takes height of content. */
  height?: number;
  /** Toggle hover effect */
  hoverEffect?: boolean;
  /** Toggle focus effect */
  focusEffect?: boolean;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** SimpleCard, is Card but without expansion, selection functionality. Useful for less complicated use-cases that require a Card. */
const SimpleCard = React.forwardRef<HTMLElement, SimpleCardProps>((props: SimpleCardProps, ref) =>
  getContext(({ RTL: rtl, theme: globalTheme }) => {
    const {
      children,
      width,
      height,
      variant,
      theme,
      ...otherProps
    } = props;
    const resolvedTheme = _merge({}, globalTheme.CARD, theme);
    return (
      <CardCore ref={ref} variant={variant} theme={resolvedTheme} {...otherProps}>
        <Styled.CardContentContainer cardHeight={height} rtl={rtl}>
          <Styled.Card rtl={rtl}>{children}</Styled.Card>
        </Styled.CardContentContainer>
      </CardCore>
    );
  }));

SimpleCard.displayName = 'SimpleCard';

SimpleCard.defaultProps = {
  variant: 'default',
  width: undefined,
  height: undefined,
  hoverEffect: true,
  focusEffect: true,
  theme: {}
};
export default SimpleCard;
